<template>
  <div>

    <DataTable
        :filters="filters"
        :loading="loading"
        :paginator="true"
        :resizableColumns="true"
        :rows="rows"
        :rowsPerPageOptions="[10, 25, 50, 100]"
        :scrollable="true"
        :selection.sync="selection"
        :value="dataRows"
        columnResizeMode="expand"
        selection-mode="multiple"
        style="height: 30px; max-width: 100% !important;"
    >

      <Column v-for="col of getCols"
              :key="col.field"
              :field="col.field"
              :filterFunction="customFilter"
              :header="col.header"
              :header-style="col.headerStyle"
              :sortable="true"
              body-style="height: 30px"
              body-class="table-data-nowrap"
              filterMatchMode="custom"
      >
        <template #filter>
          <InputText v-if="col.isTextFilter" v-model="filters[col.field]"
                     :placeholder="translate('placeholder.no.filter')" class="p-column-filter" type="text"/>
          <DropDown v-if="col.isDropDownFilter" v-model="filters[col.field]"
                    :options="getFieldOptions(col.field, col.getter)" :placeholder="translate('placeholder.no.filter')"
                    appendTo="body" class="p-column-filter" optionLabel="label" showClear styleClass="ui-column-filter">
            <template #value="slotProps">
              <div v-if="slotProps.value" class="p-dropdown-car-value">
                <span v-html="slotProps.value.label"></span>
              </div>
              <span v-else>
                                {{ slotProps.placeholder }}
                            </span>
            </template>
            <template #option="slotProps">
              <div class="p-dropdown-car-option">
                <span v-html="slotProps.option.label"></span>
              </div>
            </template>
          </DropDown>
        </template>
        <template #body="slotProps">
          <div v-html="col.getter(slotProps.data[col.field])"></div>
        </template>
      </Column>
      <template #paginatorLeft>
        Count: {{ recordCount }}
      </template>
      <template #empty>
        {{ translate('no.records') }}
      </template>
    </DataTable>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import TranslateService from "../services/translate.service";

export default {
  name: "LicencesHoldbackGrid",
  props: ['colDefinitions', 'dataRows', 'loading'],
  data() {
    return {
      filters: {},
      selection: null,
      rows: 10
    }
  },
  methods: {
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    contains(value, filter, filterLocale) {
      if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') {
        return true;
      }
      if (value === undefined || value === null) {
        return false;
      }
      var filterValue = filter.toString().toLocaleLowerCase(filterLocale);
      var stringValue = value.toString().toLocaleLowerCase(filterLocale);
      return stringValue.indexOf(filterValue) !== -1;
    },
    customFilter(value, filter) {
      if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') {
        return true;
      }
      if (value === undefined || value === null) {
        return false;
      }
      if (Object.prototype.hasOwnProperty.call(filter, 'key')) {
        return (filter.key === value);
      } else {
        return this.contains(value, filter);
      }
    },
    getFieldOptions(field, getter) {
      let valSet = new Set();
      let res = [];
      for (let row of this.dataRows) {
        if (row[field] !== '' && row[field] != null) {
          if (!valSet.has(row[field])) {
            valSet.add(row[field]);
            if (getter !== undefined) {
              let val = getter(row[field], field, row);
              res.push({key: row[field], label: val});
            } else {
              res.push({key: row[field], label: row[field]});
            }
          }
        }
      }
      res.sort(a => a.key);
      return res;
    },
  },
  computed: {
    ...mapGetters('nav', ["getContentWidth"]),
    getCols() {
      return this.colDefinitions;
    },
    recordCount() {
      return this.dataRows.length;
    },

  },
  watch: {
    selection: function () {
      this.$emit('selection', this.selection);
    }
  }
}
</script>

<style scoped>

</style>